import { DELETE_OUR_WORK_START } from '../../types';

export const delete_our_work = (payload) => ({
  type: DELETE_OUR_WORK_START,
  payload,
});
